export const Layouts = [
  ['Cartão', 'Cartão'],
  ['Curso', 'Curso'],
  ['Iniciação Científica', 'Iniciação Científica'],
  ['Pesquisa', 'Pesquisa'],
  ['Campus', 'Campus'],
  ['Pos-graduação', 'Pos-graduação'],
  ['Especialização', 'Especialização'],
];
